import { render } from "./ShowFile.vue?vue&type=template&id=f7fffcb4&scoped=true"
import script from "./ShowFile.vue?vue&type=script&lang=js"
export * from "./ShowFile.vue?vue&type=script&lang=js"

import "./ShowFile.vue?vue&type=style&index=0&id=f7fffcb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7fffcb4"]])

export default __exports__